export const gameTypes = {
  'Account Classification': 'classification',
  'Normal Balance': 'normal', 
  'Balanced Equation': 'double entry',
  'The Principles': 'principles'
};